module.exports = __webpack_public_path__ + "img/16.757c67a8.svg";